"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateRule = void 0;

var _validationFns = require("./validationFns");

var _validationRules = require("../../constants/validation/validationRules");

var validateRule = function validateRule(rule, value, name) {
  var formattedRule = rule;
  var ruleValue;

  if (typeof rule !== 'string') {
    formattedRule = Object.keys(rule)[0]; // eslint-disable-line prefer-destructuring

    ruleValue = rule[formattedRule];
  }

  switch (formattedRule) {
    case _validationRules.REQUIRED:
      return (0, _validationFns.required)(value, name);

    case _validationRules.EMAIL:
      return (0, _validationFns.email)(value);

    case _validationRules.EMAIL_MULTI:
      return (0, _validationFns.emailMulti)(value);

    case _validationRules.COLORADO_ADDRESS:
      return (0, _validationFns.validState)(value);

    case _validationRules.LETTERS_REQUIRED:
      return (0, _validationFns.lettersRequired)(value);

    case _validationRules.NUMBERS_REQUIRED:
      return (0, _validationFns.numbersRequired)(value);

    case _validationRules.FEIN:
      return (0, _validationFns.fein)(value);

    case _validationRules.SSN:
      return (0, _validationFns.ssn)(value);

    case _validationRules.PHONE_TEN_DIGIT:
      return (0, _validationFns.phoneTenDigit)(value);
    // Rules that take rule values

    case _validationRules.MINIMUM_CHARACTERS:
      return (0, _validationFns.minimumCharacters)(value, ruleValue);

    case _validationRules.MAXIMUM_CHARACTERS:
      return (0, _validationFns.maximumCharacters)(value, ruleValue);

    case _validationRules.MINIMUM_VALUE:
      return (0, _validationFns.numericValueValidator)('min', value, ruleValue);

    case _validationRules.MAXIMUM_VALUE:
      return (0, _validationFns.numericValueValidator)('max', value, ruleValue);

    default:
      return '';
  }
};

exports.validateRule = validateRule;